import type { Feature } from '../features/user/useRequestAccessMutation';

import { COMPANY_OVERVIEW_FULL_ACCESS, CONTACTS_FULL_ACCESS, INSIGHTS_LIMIT_INCREASE } from './user';

export type LockVariant =
  | 'insights-limit-reached-paid'
  | 'insights-limit-reached-trial'
  | 'insights-limit-reached-after-trial'
  | 'company-daily-limit-reached'
  | 'company-monthly-limit-reached'
  | 'company-monthly-limit-reached-nt'
  | 'contacts-disabled';

export type GainAccessKey =
  | typeof INSIGHTS_LIMIT_INCREASE
  | typeof COMPANY_OVERVIEW_FULL_ACCESS
  | typeof CONTACTS_FULL_ACCESS;

type LockProps = {
  title: string;
  description: string;
  image: string;
  feature?: Feature;
  storageKey?: GainAccessKey;
  button?: string;
};

export const NT_PURCHASE_PAGE_LINK =
  'https://account.similarweb.com/journey/purchase-global?currency=USD&package=PremiumSalesExtension&period=annually&promo&workspace=sales';

export const INSIGHTS_FEATURE_KEY = 'sam-full-access';
export const COMPANY_OVERVIEW_FEATURE_KEY = 'company-limit';
export const CONTACTS_FEATURE_KEY = 'contacts-full-access';

const GAIN_ACCESS_IMAGE = '/images/lock.svg';

export const GAIN_ACCESS_VARIANT_PROPS: Record<LockVariant, LockProps> = {
  'insights-limit-reached-trial': {
    title: 'insights.limit_reached.title',
    description: 'insights.limit_reached_trial.subtitle',
    image: GAIN_ACCESS_IMAGE,
    storageKey: INSIGHTS_LIMIT_INCREASE,
    feature: INSIGHTS_FEATURE_KEY,
  },
  'insights-limit-reached-after-trial': {
    title: 'insights.limit_reached_paid.title',
    description: 'insights.limit_reached_after_trial.subtitle',
    image: GAIN_ACCESS_IMAGE,
    storageKey: INSIGHTS_LIMIT_INCREASE,
    feature: INSIGHTS_FEATURE_KEY,
  },
  'insights-limit-reached-paid': {
    title: 'insights.limit_reached_paid.title',
    description: 'insights.limit_reached_paid.subtitle',
    image: GAIN_ACCESS_IMAGE,
    storageKey: INSIGHTS_LIMIT_INCREASE,
    feature: INSIGHTS_FEATURE_KEY,
  },
  'company-daily-limit-reached': {
    title: 'overview.limit_reached.title',
    description: 'overview.limit_reached.description',
    image: GAIN_ACCESS_IMAGE,
    storageKey: COMPANY_OVERVIEW_FULL_ACCESS,
    feature: COMPANY_OVERVIEW_FEATURE_KEY,
  },
  'company-monthly-limit-reached': {
    title: 'overview.monthly_limit_reached.title',
    description: 'overview.monthly_limit_reached.description',
    image: GAIN_ACCESS_IMAGE,
    storageKey: COMPANY_OVERVIEW_FULL_ACCESS,
    feature: COMPANY_OVERVIEW_FEATURE_KEY,
  },
  'contacts-disabled': {
    feature: 'contacts-full-access',
    title: 'company.contacts.disabled.title',
    description: 'company.contacts.disabled.text',
    storageKey: CONTACTS_FULL_ACCESS,
    image: GAIN_ACCESS_IMAGE,
    button: 'common.gain_access',
  },
  'company-monthly-limit-reached-nt': {
    title: 'overview.need_more_credits.title',
    description: 'overview.need_more_credits.description',
    image: GAIN_ACCESS_IMAGE,
    storageKey: COMPANY_OVERVIEW_FULL_ACCESS,
    feature: COMPANY_OVERVIEW_FEATURE_KEY,
  },
};
